import React, { useState } from 'react'
import { Card, Flex, Switch, Typography } from 'antd'
import { useParams } from 'react-router'
import fileDownload from 'js-file-download'
import { useSelector } from 'react-redux'
import AiAcceptanceRateChart from './AiAcceptanceRateChart'
import { useLazyExportAiAcceptanceRateQuery } from '../../../../../../../store/apis/analytics.api'
import assignmentSelectors from '../../../../../../../store/selectors/assignment.selectors'
import ExportDropdownButton from '../../../../../../../components/common/export/ExportDropdownButton'

const { Text } = Typography

const AiAcceptanceRateCard = () => {
    const { token } = useParams()
    const [includeAutoApproved, setIncludeAutoApproved] = useState(true)
    const assignmentName = useSelector(assignmentSelectors.name)

    const [exportAiAcceptanceRate, exportResult] = useLazyExportAiAcceptanceRateQuery()

    const handleExport = async format => {
        const response = await exportAiAcceptanceRate({
            token,
            format,
            include_auto_approved: includeAutoApproved,
        })

        if ('data' in response) {
            const fileExtension = format.toLowerCase() === 'xlsx' ? 'xlsx' : 'csv'
            fileDownload(response.data, `${assignmentName}_ai_acceptance_rate.${fileExtension}`)
        }
    }

    const extra = (
        <Flex align='center' gap={8}>
            <Text>Include Auto-Approved</Text>
            <Switch checked={includeAutoApproved} onChange={setIncludeAutoApproved} />
            <ExportDropdownButton
                onExport={handleExport}
                formats={['csv', 'xlsx']}
                loading={exportResult.isLoading}
                buttonText='Export'
            />
        </Flex>
    )

    return (
        <Card title='AI Acceptance Rate' extra={extra}>
            <AiAcceptanceRateChart token={token} includeAutoApproved={includeAutoApproved} />
        </Card>
    )
}

export default AiAcceptanceRateCard
